import { EditDialogHeaderButtons, Icon, Stack, Tooltip, Typography } from "@tm/components"
import { useLocalization } from "@tm/localization"

type Props = {
    customPartTitleText?: string
    isSaving?: boolean
    onCloseButtonClick(): void
}

export function EditDialogHeader({ isSaving, customPartTitleText, onCloseButtonClick }: Props) {
    const { translateText } = useLocalization()

    return (
        <Stack direction="row" justifyContent="space-between" alignItems="start">
            {customPartTitleText ? (
                <Stack direction="row" alignContent="center" gap={1} alignItems="center">
                    <Icon name="individual-article" size="large" />
                    <Typography variant="h2">{customPartTitleText}</Typography>
                    <Tooltip title={translateText(13908)} placement="right">
                        <Icon name="info" />
                    </Tooltip>
                </Stack>
            ) : (
                <Typography variant="h2">{translateText(13929)}</Typography>
            )}
            <EditDialogHeaderButtons isSaving={isSaving} onCloseButtonClick={onCloseButtonClick} />
        </Stack>
    )
}
